// src/domains/shell.keys.ts（TD-823 键归属：多 owner 片共引用的顶层键与 shell 新增片键）
export const KEYS = [
  'appBoot', 'closeModal', 'goDeposit', 'goHome', 'goMe', 'goWallet', 'goWithdrawUsdt', 'isApp', 'modal', 'modalOpen', 'setEn', 'setZh',
  'showTabs', 'stop', 't', 'tabHomeStyle', 'tabMeStyle', 'tabWalletStyle', 'tgIdText', 'tgUserText', 'toast',
  'isSessionPage', 'sessionPageText', 'closeApp', 'totpSubText', 'totpCode', 'onTotpCode', 'totpErr', 'cancelTotp', 'confirmTotp', 'busyTotp',
  // U-22 E-04 次级列表骨架行 / 重试（cards / wallet / me 列表片共引用）
  'skelRows', 'retryText',
  // U-24 未开通邮箱登录常驻提示条（cards 0083 / me 0255 两片共引用）
  'showGateBar', 'gateBarText', 'gateBarBtnText', 'openGate',
] as const;
export const MODAL_KEYS = ['isInfo', 'isTicket', 'rows', 'title', 'isTotp', 'note'] as const;
// 本域在 H5State 上的切片键（h5-keys 断言 initialState 含该键；null = 尚无原生切片）
export const SLICE: string | null = 'sh';
